module.exports = __webpack_public_path__ + "static/media/green.e2cfb232.svg";